import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import {
  Visibility as VisibleIcon,
  VisibilityOff as HiddenIcon,
} from '@mui/icons-material';
import type { WineListItemVisibility } from '../../types/venue';

interface Props {
  visibility: WineListItemVisibility;
  /**
   * When provided, the chip becomes clickable and calls this handler.
   * Omit for read-only display.
   */
  onChange?: (next: WineListItemVisibility) => void;
  size?: 'small' | 'medium';
}

const WineListVisibilityToggle: React.FC<Props> = ({
  visibility,
  onChange,
  size = 'small',
}) => {
  const isLive = visibility === 'LIVE';

  const chip = (
    <Chip
      icon={isLive ? <VisibleIcon fontSize="small" /> : <HiddenIcon fontSize="small" />}
      label={isLive ? 'Live' : 'Hidden'}
      size={size}
      onClick={
        onChange
          ? () => onChange(isLive ? 'HIDDEN' : 'LIVE')
          : undefined
      }
      sx={{
        fontWeight: 600,
        fontSize: size === 'small' ? '0.7rem' : '0.75rem',
        color: isLive ? '#1a7f37' : '#6e7781',
        backgroundColor: isLive ? '#dafbe1' : '#f6f8fa',
        border: 'none',
        height: size === 'small' ? 22 : 28,
        cursor: onChange ? 'pointer' : 'default',
        '& .MuiChip-icon': {
          fontSize: '0.875rem',
          color: 'inherit',
        },
      }}
    />
  );

  if (!onChange) return chip;

  return (
    <Tooltip title={isLive ? 'Click to hide from list' : 'Click to make live'} placement="top">
      {chip}
    </Tooltip>
  );
};

export default WineListVisibilityToggle;
